import checkDependsOn from './checkDependsOn';
import checkExclusiveOr from './checkExclusiveOr';
import checkExclude from './checkExclude';

const checkDependencies = (parts, flatConfigurationParts) => [
    ...checkDependsOn(parts, flatConfigurationParts),
    ...checkExclusiveOr(parts, flatConfigurationParts),
    ...checkExclude(parts, flatConfigurationParts),
];

export default checkDependencies;
